import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const postRejectToInitiator = createApi(`RejectToInitiatorSlice`,"POST");

const RejectToInitiatorSlice = createSlice({
  name: 'RejectToInitiatorSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postRejectToInitiator.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postRejectToInitiator.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postRejectToInitiator.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default RejectToInitiatorSlice.reducer;